var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"grey lighten-3 pt-3"},[_c('div',{attrs:{"id":"core-view"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }